import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCoffee, FiMoon, FiSun, FiActivity, FiArrowRight } = FiIcons;

const SmartRecommendations = ({ onSelectCategory }) => {
  const timeContext = useMemo(() => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 11) return { title: 'Morning Essentials', icon: FiCoffee, color: 'text-amber-600', suggestions: [{ id: 'cafe', label: 'Coffee', icon: 'Coffee' }, { id: 'bakery', label: 'Bakery', icon: 'ShoppingBag' }] };
    if (hour >= 11 && hour < 17) return { title: 'Mid-Day Discovery', icon: FiSun, iconColor: 'text-indigo-600', suggestions: [{ id: 'restaurants', label: 'Lunch', icon: 'Utensils' }, { id: 'bank', label: 'Banks', icon: 'CreditCard' }] };
    return { title: 'Evening Relax', icon: FiMoon, iconColor: 'text-slate-950', suggestions: [{ id: 'restaurants', label: 'Dinner', icon: 'Utensils' }, { id: 'pharmacy', label: 'Pharmacy', icon: 'Activity' }] };
  }, []);

  return (
    <div className="mb-10 px-2">
      <h4 className="text-[10px] font-black text-slate-700 uppercase tracking-[0.2em] mb-4">Smart Suggestions</h4>
      <div className="bg-white rounded-[2.5rem] p-6 border border-slate-200 high-contrast-shadow">
        <div className="flex items-center gap-3 mb-6">
          <SafeIcon icon={timeContext.icon} className={`text-xl ${timeContext.iconColor || timeContext.color}`} />
          <h3 className="text-xl font-black text-slate-950 tracking-tight">{timeContext.title}</h3>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {timeContext.suggestions.map((item) => (
            <button 
              key={item.id} 
              onClick={() => onSelectCategory(item.id)}
              className="bg-white p-4 rounded-2xl border-2 border-slate-100 hover:border-indigo-600 transition-all flex items-center justify-between group"
            >
              <span className="text-xs font-black text-slate-950 uppercase tracking-tight">{item.label}</span>
              <SafeIcon icon={FiArrowRight} className="text-slate-300 group-hover:text-indigo-600" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SmartRecommendations;